'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
}); // ELEMENTS

var ACCORDION = exports.ACCORDION = 'PUIAccordion';
var ACCORDION_CARD = exports.ACCORDION_CARD = 'PUIAccordionCard';
var ACCORDION_LIST = exports.ACCORDION_LIST = 'PUIAccordionList';
var ACCORDION_LIST_ITEM = exports.ACCORDION_LIST_ITEM = 'PUIAccordionListItem';
var ACTIONBAR = exports.ACTIONBAR = 'PUIActionBar';
var AVATAR = exports.AVATAR = 'PUIAvatar';
var BADGE = exports.BADGE = 'PUIBadge';
var BANNER_CAROUSEL = exports.BANNER_CAROUSEL = 'PUIBannerCarousel';
var BOX = exports.BOX = 'PUIBox';
var BUTTON = exports.BUTTON = 'PUIButton';
var CARDBOX = exports.CARDBOX = 'PUICardbox';
var CHECKBOX = exports.CHECKBOX = 'PUICheckbox';
var CLEARFIX = exports.CLEARFIX = 'PUIClearfix';
var DIVIDER = exports.DIVIDER = 'PUIDivider';
var DROPDOWN = exports.DROPDOWN = 'PUIDropdown';
var DROPZONE = exports.DROPZONE = 'PUIDropzone';
var FLEX = exports.FLEX = 'PUIFlex';
var ICON = exports.ICON = 'PUIIcon';
var IMAGE = exports.IMAGE = 'PUIImage';
var ILLUSTRATION = exports.ILLUSTRATION = 'PUIIllustration';
var ILLUSTRATION_DYNAMIC = exports.ILLUSTRATION_DYNAMIC = 'PUIIllustrationDynamic';
var INDICATOR = exports.INDICATOR = 'PUIIndicator';
var LOADER = exports.LOADER = 'PUILoader';
var MAPPINGBOX = exports.MAPPINGBOX = 'PUIMappingbox';
var OVERLAY = exports.OVERLAY = 'PUIOverlay';
var PAGINATION = exports.PAGINATION = 'PUIPagination';
var PROGRESS_RING = exports.PROGRESS_RING = 'PUIProgressRing';
var SPINNER = exports.SPINNER = 'PUISpinner';
var CLASSICTABLE = exports.CLASSICTABLE = 'PUIClassicTable';
var TABLE = exports.TABLE = 'PUITable';
var TABS = exports.TABS = 'PUITabs';
var TAGICON = exports.TAGICON = 'PUITagIcon';
var TEXT = exports.TEXT = 'PUIText';
var TOAST = exports.TOAST = 'PUIToast';
var TWO_STEP_BUTTON = exports.TWO_STEP_BUTTON = 'PUITwoStepButton';
var WATERFALL_CHART = exports.WATERFALL_CHART = 'PUIWaterfallChart';
var MULTIPLE_CHOICE_RESPONSES = exports.MULTIPLE_CHOICE_RESPONSES = 'PUIMultipleChoiceResponses';
var QUESTION_RESPONSES = exports.QUESTION_RESPONSES = 'PUIQuestionResponses';
var FORM_RESPONSES = exports.FORM_RESPONSES = 'PUIFormResponses';
var LAYOUT = exports.LAYOUT = 'PUILayout';
var DATEPICKER = exports.DATEPICKER = 'PUIDatepicker'; // BANNER

var BANNER = exports.BANNER = 'PUIBanner';
var BANNER_CLOSE = exports.BANNER_CLOSE = 'PUIBannerClose';
var BANNER_LEFT = exports.BANNER_LEFT = 'PUIBannerLeft';
var BANNER_RIGHT = exports.BANNER_RIGHT = 'PUIBannerRight'; // TABMENU

var TAB_MENU = exports.TAB_MENU = 'PUITabMenu';
var TAB_MENU_ITEM = exports.TAB_MENU_ITEM = 'PUITabMenuItem'; // RADIOBUTTONMENU

var RADIO_BUTTON_MENU = exports.RADIO_BUTTON_MENU = 'PUIRadioButtonMenu';
var RADIO_BUTTON_MENU_ITEM = exports.RADIO_BUTTON_MENU_ITEM = 'PUIRadioButtonMenuItem'; // BORDER

var BORDER = exports.BORDER = 'PUIBorder';
var BORDER_MENU = exports.BORDER_MENU = 'PUIBorderMenu';
var BORDER_MENU_ITEM = exports.BORDER_MENU_ITEM = 'PUIBorderMenuItem'; // CARD

var CARD = exports.CARD = 'PUICard';
var CARD_IMAGE = exports.CARD_IMAGE = 'PUICardImage';
var CARD_BODY = exports.CARD_BODY = 'PUICardBody';
var CARD_FOOTER = exports.CARD_FOOTER = 'PUICardFooter';
var CARD_FOOTER_ITEM = exports.CARD_FOOTER_ITEM = 'PUICardFooterItem';
var CARD_MENU_ITEM = exports.CARD_MENU_ITEM = 'PUICardMenuItem'; // FORM

var FORM = exports.FORM = 'PUIForm';
var FORM_CHECK_GROUP = exports.FORM_CHECK_GROUP = 'PUIFormCheckGroup';
var FORM_CHECKBOX = exports.FORM_CHECKBOX = 'PUIFormCheckbox';
var FORM_TOGGLE_CHECKBOX = exports.FORM_TOGGLE_CHECKBOX = 'PUIFormToggleCheckbox';
var FORM_CHECKBOX_CLASSIC = exports.FORM_CHECKBOX_CLASSIC = 'PUIFormCheckboxClassic';
var FORM_COLOR_PICKER = exports.FORM_COLOR_PICKER = 'PUIFormColorPicker';
var FORM_DURATION_INPUT = exports.FORM_DURATION_INPUT = 'PUIFormDurationInput';
var FORM_FIELD = exports.FORM_FIELD = 'PUIFormField';
var FORM_ICON_LIST = exports.FORM_ICON_LIST = 'PUIFormIconList';
var FORM_ICON_SELECT = exports.FORM_ICON_SELECT = 'PUIFormIconSelect';
var FORM_INPUT = exports.FORM_INPUT = 'PUIFormInput';
var FORM_LABEL = exports.FORM_LABEL = 'PUIFormLabel';
var FORM_RADIO_BUTTON = exports.FORM_RADIO_BUTTON = 'PUIFormRadioButton';
var FORM_RADIO_GROUP = exports.FORM_RADIO_GROUP = 'PUIFormRadioGroup';
var FORM_SELECT = exports.FORM_SELECT = 'PUIFormSelect';
var FORM_SLIDER = exports.FORM_SLIDER = 'PUIFormSlider';
var FORM_TEXTAREA = exports.FORM_TEXTAREA = 'PUIFormTextarea';
var FORM_TOGGLE_BUTTON = exports.FORM_TOGGLE_BUTTON = 'PUIFormToggleButton';
var FORM_ICON_TOGGLE_BUTTON = exports.FORM_ICON_TOGGLE_BUTTON = 'PUIFormIconToggleButton';
var FORM_VIDEO_INPUT = exports.FORM_VIDEO_INPUT = 'PUIFormVideoInput';
var FORM_COPY_INPUT = exports.FORM_COPY_INPUT = 'PUIFormCopyInput';
var FORM_EDIT_INPUT = exports.FORM_EDIT_INPUT = 'PUIFormEditInput';
var FORM_SEARCH_INPUT = exports.FORM_SEARCH_INPUT = 'PUIFormSearchInput'; // SMART FORM

var SMART_FORM = exports.SMART_FORM = 'PUISmartForm';
var SMART_FORM_INPUT = exports.SMART_FORM_INPUT = 'PUISmartFormInput';
var SMART_FORM_TEXT_INPUT = exports.SMART_FORM_TEXT_INPUT = 'PUISmartFormTextInput';
var SMART_FORM_CHECKBOX = exports.SMART_FORM_CHECKBOX = 'PUISmartFormCheckbox';
var SMART_FORM_TEXTAREA = exports.SMART_FORM_TEXTAREA = 'PUISmartFormTextarea';
var SMART_FORM_SUBMIT_BUTTON = exports.SMART_FORM_SUBMIT_BUTTON = 'PUISmartFormSubmitButton'; // export const SMART_FORM_SELECT = 'PUISmartFormSelect';
// GRID

var GRID = exports.GRID = 'PUIGrid';
var GRID_COLUMNS = exports.GRID_COLUMNS = 'PUIGridColumns';
var GRID_COLUMN = exports.GRID_COLUMN = 'PUIGridColumn';
var GRID_TILE = exports.GRID_TILE = 'PUIGridTile'; // LIST

var LIST = exports.LIST = 'PUIList';
var LIST_CONTENT = exports.LIST_CONTENT = 'PUIListContent';
var LIST_ICON = exports.LIST_ICON = 'PUIListIcon';
var LIST_ITEM = exports.LIST_ITEM = 'PUIListItem'; // MENU

var MENU = exports.MENU = 'PUIMenu';
var MENU_ITEM = exports.MENU_ITEM = 'PUIMenuItem'; // NAVBAR

var NAVBAR = exports.NAVBAR = 'PUINavbar';
var NAVBAR_BUTTON = exports.NAVBAR_BUTTON = 'PUINavbarButton';
var NAVBAR_CENTER = exports.NAVBAR_CENTER = 'PUINavbarCenter';
var NAVBAR_ITEM = exports.NAVBAR_ITEM = 'PUINavbarItem';
var NAVBAR_LEFT = exports.NAVBAR_LEFT = 'PUINavbarLeft';
var NAVBAR_LIST = exports.NAVBAR_LIST = 'PUINavbarList';
var NAVBAR_LIST_ITEM = exports.NAVBAR_LIST_ITEM = 'PUINavbarListItem';
var NAVBAR_LOGO = exports.NAVBAR_LOGO = 'PUINavbarLogo';
var NAVBAR_RIGHT = exports.NAVBAR_RIGHT = 'PUINavbarRight';
var NAVBAR_SUB_NAV_ITEM = exports.NAVBAR_SUB_NAV_ITEM = 'PUINavbarSubNavItem'; // SIDEBAR

var SIDEBAR = exports.SIDEBAR = 'PUISidebar';
var SIDEBAR_CLOSE = exports.SIDEBAR_CLOSE = 'PUISidebarClose';
var SIDEBAR_NAV_ENTRY = exports.SIDEBAR_NAV_ENTRY = 'PUISidebarNavEntry';
var SIDEBAR_IMAGE_TILE = exports.SIDEBAR_IMAGE_TILE = 'PUISidebarImageTile';
var SIDEBAR_ITEM = exports.SIDEBAR_ITEM = 'PUISidebarItem';
var SIDEBAR_LOADER = exports.SIDEBAR_LOADER = 'PUISidebarLoader';
var SIDEBAR_NAV = exports.SIDEBAR_NAV = 'PUISidebarNav';
var SIDEBAR_NAV_TITLE = exports.SIDEBAR_NAV_TITLE = 'PUISidebarNavTitle';
var SIDEBAR_SUBTITLE = exports.SIDEBAR_SUBTITLE = 'PUISidebarSubtitle';
var SIDEBAR_TILE = exports.SIDEBAR_TILE = 'PUISidebarTile';
var SIDEBAR_TILE_LOADING = exports.SIDEBAR_TILE_LOADING = 'PUISidebarTileLoading';
var SIDEBAR_TITLE = exports.SIDEBAR_TITLE = 'PUISidebarTitle';
var SIDEBAR_SCROLL_TOP = exports.SIDEBAR_SCROLL_TOP = 'PUISidebarScrollTop'; // SLIDES

var SLIDES = exports.SLIDES = 'PUISlides';
var SLIDES_DOT = exports.SLIDES_DOT = 'PUISlidesDot';
var SLIDES_CONTROLS = exports.SLIDES_CONTROLS = 'PUISlidesControls';
var SLIDES_ARROW = exports.SLIDES_ARROW = 'PUISlidesArrow';
var SLIDES_IMAGE = exports.SLIDES_IMAGE = 'PUISlidesImage';
var SLIDES_TEXT = exports.SLIDES_TEXT = 'PUISlidesText';
var SLIDES_QUOTE = exports.SLIDES_QUOTE = 'PUISlidesQuote'; // VALUE GROUP

var VALUE_GROUP = exports.VALUE_GROUP = 'PUIValueGroup';
var VALUE_GROUP_ITEM = exports.VALUE_GROUP_ITEM = 'PUIValueGroupItem';
var VALUE_GROUP_ITEM_DISABLED_INFO = exports.VALUE_GROUP_ITEM_DISABLED_INFO = 'PUIValueGroupItemDisabledInfo'; // NAVIGATION BAR

var NAVIGATION_BAR = exports.NAVIGATION_BAR = 'PUINavigationBar';
var NAVIGATION_BAR_TITLE = exports.NAVIGATION_BAR_TITLE = 'PUINavigationBarTitle';
var NAVIGATION_BAR_GROUP = exports.NAVIGATION_BAR_GROUP = 'PUINavigationBarGroup';
var NAVIGATION_BAR_LOGO = exports.NAVIGATION_BAR_LOGO = 'PUINavigationBarLogo';
var NAVIGATION_BAR_MENU = exports.NAVIGATION_BAR_MENU = 'PUINavigationBarMenu';
var NAVIGATION_BAR_MENU_ITEM = exports.NAVIGATION_BAR_MENU_ITEM = 'PUINavigationBarMenuItem';
var NAVIGATION_BAR_MENU_ICON_ITEM = exports.NAVIGATION_BAR_MENU_ICON_ITEM = 'PUINavigationBarIconMenuItem';
var NAVIGATION_BAR_MENU_TEXT_ITEM = exports.NAVIGATION_BAR_MENU_TEXT_ITEM = 'PUINavigationBarTextMenuItem'; // RESPONSE

var RESPONSE = exports.RESPONSE = 'PUIResponse';
var RATING_RESPONSE = exports.RATING_RESPONSE = 'PUIRatingResponse';
var QUIZ_RESPONSE = exports.QUIZ_RESPONSE = 'PUIQuizResponse';
var QUESTION_RESPONSE = exports.QUESTION_RESPONSE = 'PUIQuestionResponse';
var TEXT_RESPONSE = exports.TEXT_RESPONSE = 'PUITextResponse';
var FORM_RESPONSE = exports.FORM_RESPONSE = 'PUIFormResponse'; // SIMPLE TABLE

var SIMPLE_TABLE = exports.SIMPLE_TABLE = 'PUISimpleTable';
var SIMPLE_TABLE_HEADER = exports.SIMPLE_TABLE_HEADER = 'PUISimpleTableHeader';
var SIMPLE_TABLE_HEADER_CELL = exports.SIMPLE_TABLE_HEADER_CELL = 'PUISimpleTableHeaderCell';
var SIMPLE_TABLE_HEADER_SORT_HANDLER = exports.SIMPLE_TABLE_HEADER_SORT_HANDLER = 'PUISimpleTableHeaderSortHandler';
var SIMPLE_TABLE_TEXT_CELL = exports.SIMPLE_TABLE_TEXT_CELL = 'PUISimpleTableHeaderTextCell';
var SIMPLE_TABLE_TIME_CELL = exports.SIMPLE_TABLE_TIME_CELL = 'PUISimpleTableHeaderTimeCell'; // SEARCH BAR

var SEARCH_BAR = exports.SEARCH_BAR = 'PUISearchBar';